import {styled} from '@mui/material/styles'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import {Grid, TextField} from '@mui/material'
import Button1 from './Button1'
import React, {useState} from 'react'

interface TagsEditorProps {
  tags: string[]
  onChange: (tags: string[]) => void
}

export default function TagsEditor(props: TagsEditorProps) {
  const [tagToAdd, setTagToAdd] = useState<string>('')
  
  const handleDelete = (tag: string) => {
    props.onChange([...props.tags.filter(t => t !== tag)])
  }
  
  const handleAdd = (e: any) => {
    e.preventDefault()
    const slug = slugify(tagToAdd)
    
    if (!slug) return
    
    if (props.tags.includes(slug)) {
      setTagToAdd('')
      return
    }
    props.onChange([...props.tags, slug])
    setTagToAdd('')
  }
   
  const slugify = (str: string): string => {
    if (!str) return ''
    
    // Remove all characters that are not alphanumeric or space or dash
    str = str.replace(/[^a-zA-Z0-9\s-]/g, '')
    
    // Replace all spaces with dashes
    str = str.replace(/\s+/g, '-')
    
    // Remove all dashes from the beginning and end of the string
    str = str.replace(/^-+/, '').replace(/-+$/, '')
    
    // Change multiple dashes to single dashes
    str = str.replace(/-+/g, '-')
    
    return str.toLowerCase()
  }

  return (
    <>
      <Grid container spacing={1} sx={{maxWidth: '380px'}}>
        <Grid item xs={6}>
          <TextField
            value={tagToAdd}
            onChange={e => setTagToAdd(e.target.value)}
            size="small"
            variant="outlined"
            label="Tag"
            margin="normal"
            fullWidth
          >
          </TextField>
        </Grid>
        <Grid item xs={6} sx={{mx: 0, mt: 2}}>
          <Button1 onClick={handleAdd}>Add Tag</Button1>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'left',
          flexWrap: 'wrap',
          listStyle: 'none',
          p: 0.5,
          m: 0
        }}
        component="ul"
      >
        {props.tags.map((tag) => {
          return (
            <StyledListItem key={tag}>
              <Chip label={tag} onDelete={_ => handleDelete(tag)}/>
            </StyledListItem>
          )
        })}
      </Box>
    </>
  )
}

const StyledListItem = styled('li')(({theme}) => ({
  margin: theme.spacing(0.5)
}))
